module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Guitarra.36680b40.png";